<template>
	<div class="userLogin" :style="isAdminLogin?'':'display:none;'">
		<!-- <canvas class="canvas_login_bg" style="width: 100%;height: calc(100vh);position: absolute;z-index: 4;"></canvas> -->
		<div class="bg" :style="[{'background-image':'url('+bgUrl+')'}]"></div>
		<el-row>
			<el-card class="box-card">
				<el-col style="text-align: center;">
					<h2 style="color: #fff;">{{sysName}}</h2>
				</el-col>
				<!-- 账号密码登录 -->
				<el-form label-width="80px" v-if="!phoneLogin">
					<el-col style="text-align: center;margin-bottom: 15px;">
						<el-input placeholder="请输入您的用户名" prefix-icon="el-icon-user" class="login_input_text"
							v-model="loginid" @keyup.enter.native="loginUser()">
						</el-input>
					</el-col>
					<el-col style="text-align: center;margin-bottom: 15px;">
						<el-input placeholder="请输入密码" prefix-icon="el-icon-lock" class="login_input_text"
							v-model="password" show-password @keyup.enter.native="loginUser()">
						</el-input>
					</el-col>
					<el-col style="margin-bottom: 15px;">
						<el-button type="primary" @click="loginUser()" class="login_button">立即登录</el-button>
					</el-col>
					<el-col style="text-align: center;" v-show="!isAdminLogin">
						<el-button style="color: #fff;" type="text" @click="$emit('updataLoginType')">手机号短信验证登录
						</el-button>
					</el-col>
				</el-form>
				<!-- 手机号短信验证登录 -->
				<el-form label-width="80px" v-else>
					<el-col style="text-align: center;margin-bottom: 15px;">
						<el-input placeholder="请输入您的手机号" prefix-icon="el-icon-user" class="login_input_text"
							v-model="loginid" @keyup.enter.native="loginUser()">
						</el-input>
					</el-col>
					<el-col style="text-align: center;margin-bottom: 15px;">
						<el-input v-model="password" prefix-icon="el-icon-lock" class="login_input_text"
							placeholder="请输入短信验证码">
							<template slot="append">
								<el-button @click="send(phoneNumber)" v-if="phoneNumber.time==0">
									发送</el-button>
								<el-button v-else>{{phoneNumber.time}}s</el-button>
							</template>
						</el-input>
					</el-col>
					<el-col style="margin-bottom: 15px;">
						<el-button type="primary" @click="loginUser()" class="login_button">立即登录</el-button>
					</el-col>
					<el-col style="text-align: center;">
						<el-button style="color: #fff;" type="text" @click="$emit('updataLoginType')">账号密码登录</el-button>
					</el-col>
				</el-form>
			</el-card>
		</el-row>
	</div>
</template>

<script>
	import {
		mapMutations,
		mapGetters,
		mapActions
	} from 'vuex'

	export default {
		data() {
			return {
				loginid: "",
				password: "",
				SavePassword: false, //保存密码
				drawer: false, //忘记密码
				ChangePassword: {
					phone: '',
					code: '',
					newpwd: '',
					time: 60,
					IntervalID: ''
				},
				phoneNumber: {
					number: '',
					code: '',
					time: 0
				},
			}
		},
		props: {
			//登录页面背景图
			bgUrl: {
				type: String,
				default: '/img/banner.png'
			},
			//产品ID
			productID: {
				type: String,
				default: 'webPlatform'
			},
			// 登录成功，跳转地址
			routerUrl: {
				type: String,
				default: '/sys'
			},
			// 允许登录用户角色
			role: {
				type: Array
			},
			// 登录框上的系统名称
			sysName: {
				type: String,
				default: '后台数据管理'
			},
			isAdminLogin: {
				type: Boolean,
				default: false
			},
			phoneLogin: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			...mapGetters(['getUserInfo', 'getToken'])
		},
		created() {
			localStorage.removeItem("sysCourseModels")
			localStorage.removeItem("practice_questions")
			localStorage.removeItem("nctWebglCase")
			localStorage.removeItem("sysjhskjModels")
			localStorage.removeItem("store")

			let ticket = this.$route.query.ticket
			if (ticket != null) {
				//验证账号是否存在
				this.checkData(ticket)
			}
		},
		methods: {
			...mapMutations(['setUserInfo', 'setToken']),
			...mapActions(['UserLogin', 'send_phoneCode']),
			checkData(val) {
				this.$http.get('api/User/ServiceValidate/' + val).then(res => {
					if (res.data.code == 1) {
						this.setUserInfo(res.data.data.user)
						this.$http.token = res.data.token
						this.$http.defaults.headers.Authorization = 'Bearer ' + res.data.token

						//跳转页面
						this.$router.push({
							path: this.routerUrl
						})
					}
				})
			},
			// 账号密码登录
			loginUser() {
				if (this.loginid != "" && this.password != "") {
					let postData = {
						loginid: this.loginid,
						loginPwd: this.password,
						platform: 'web',
						productID: this.productID,
						deviceID: navigator.userAgent,
						phoneLogin: this.phoneLogin
					}

					this.UserLogin(postData).then(res => {
						if (res.data.code == '1') {
							// 解密
							let _keystr = res.data.token.substring(res.data.token.length - 16, res.data.token
								.length)
							let _data = this.$aes.Decrypt(res.data.data, _keystr.split('').reverse().join(''), res
								.data.token.substring(0, 16))
							let resData = JSON.parse(_data)
							if (this.role.indexOf(resData.roleID) > -1) {
								//存储信息到 状态管理Store 中
								this.setUserInfo(resData)
								localStorage.setItem('yjwltoken', res.data.token)
								this.$http.token = res.data.token
								this.$http.defaults.headers.Authorization = 'Bearer ' + res.data.token

								//跳转页面
								this.$router.push({
									path: this.routerUrl
								})
							} else {
								this.$message({
									message: '用户角色无权限登录',
									type: 'info'
								})
							}
						} else {
							// this.$message({
							// 	message: res.data.message,
							// 	type: 'info'
							// })
							alert(res.data.message);
						}
					}).catch(ex => {
						// this.$message({
						// 	message: ex.data,
						// 	type: 'info'
						// })
						alert(ex.data);
					})
				} else {
					let _msg = '账号或密码不能为空'
					if (this.phoneLogin) {
						_msg = '手机号或短信验证码不能为空'
					}

					this.$message({
						message: _msg,
						type: 'info'
					})
				}
			},
			// 发送短信验证码
			send(model) {

				if (!/^1[3456789]\d{9}$/.test(this.loginid) || this.loginid === '') {
					this.$message({
						message: '手机号格式不正确',
						type: 'info'
					})
				}

				let _data = new FormData()
				_data.append('phoneNumber', this.loginid)

				this.send_phoneCode(_data).then(
					res => {
						if (res.data.code == 1) {
							model.time = 60
							let _time = setInterval(function() {
								model.time--
								if (model.time == 0)
									clearInterval(_time)
							}, 1000)
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							})
						}
					})
			}
		},
		mounted() {
			// //禁用Ctrl+C
			// let _this = this
			// let canvasscript = require('../../util/canvas-script.js').default
		}
	}
</script>
<style>
	input:-webkit-autofill {
		-webkit-box-shadow: 0 0 0px 1000px white inset;
	}

	.login_input_text input {
		background-color: rgba(255, 255, 255, .075);
		border-color: rgba(255, 255, 255, .075);
		color: rgba(255, 255, 255, .8);


		color: #ffffff;
		/* 	font-weight: 900;
		letter-spacing: 2px; */
	}
</style>
<style scoped lang="scss">
	.userLogin {
		.bg {
			// background-image: url('../../../public/img/banner.png');
			background-size: cover;
			width: 100%;
			height: 100%;
			position: absolute;
			z-index: -1;
			filter: blur(0px);
			// transform: scale(1.1);
		}

		.el-row {
			width: 100%;
			height: 100%;
			min-height: 100vh;

			.box-card {
				z-index: 5;
				width: 500px;
				height: 320px;
				position: absolute;
				top: 50%;
				margin-top: -200px;
				left: 50%;
				margin-left: -250px;
				background-color: #388de1;
				opacity: 0.9;
				padding: 0px 30px;
				border-radius: 3px;
				border: 0px;

				.login_button {
					width: 100%;
				}
			}
		}
	}
</style>